import * as yup from 'yup';
import { unformatPhone } from '@/utils/index';

const emailSchema = yup
  .object({
    email1: yup.string().trim().email('Please enter a valid email address.'),
    email2: yup.string().trim().email('Please enter a valid email address.'),
  })
  .required();

const phoneSchema = yup
  .object({
    phone1: yup
      .string()
      .test('phone', 'Please enter a valid phone number.', (value) => {
        if (!value) return true; // pass validation if form is empty
        const PhoneNumberLength = new RegExp(/\d{10,11}$/g);
        const NorthAmericaPhoneNumber = new RegExp(
          /^(?:\+?1?)[2-9]\d{2}[2-9](?!(1)\1)[\d]{2}\d{4}$/
        );

        const unformattedPhone = unformatPhone(value || '');

        const isValidPhoneNumberLenght = PhoneNumberLength.test(
          unformattedPhone || ''
        );
        const isValidNorthAmericaPhoneNumber = NorthAmericaPhoneNumber.test(
          unformattedPhone || ''
        );

        return isValidNorthAmericaPhoneNumber && isValidPhoneNumberLenght;
      }),
    phone2: yup
      .string()
      .test('phone', 'Please enter a valid phone number.', (value) => {
        if (!value) return true; // pass validation if form is empty
        const PhoneNumberLength = new RegExp(/\d{10,11}$/g);
        const NorthAmericaPhoneNumber = new RegExp(
          /^(?:\+?1?)[2-9]\d{2}[2-9](?!(1)\1)[\d]{2}\d{4}$/
        );

        const unformattedPhone = unformatPhone(value || '');

        const isValidPhoneNumberLenght = PhoneNumberLength.test(
          unformattedPhone || ''
        );
        const isValidNorthAmericaPhoneNumber = NorthAmericaPhoneNumber.test(
          unformattedPhone || ''
        );

        return isValidNorthAmericaPhoneNumber && isValidPhoneNumberLenght;
      }),
  })
  .required();

// the following are placeholders defined to fix typescript errors

const usernameSchema = yup.object().required();
const propertySchema = yup.object().required();

export const validationsByReportType = {
  social_network_report: emailSchema,
  reverse_phone_report: phoneSchema,
  username_report: usernameSchema,
  property_report: propertySchema,
};
